export interface MatchResult {
    matchLevel: "high" | "mid" | "low" | "none" | "manual";
    matchPercentage: number;
}

export const calculateSimilarity = (text1: string, text2: string): number => {
    if (!text1 || !text2) return 0;

    const words1 = text1.toLowerCase().split(/\s+/).filter(word => word.length > 2);
    const words2 = text2.toLowerCase().split(/\s+/).filter(word => word.length > 2);

    if (words1.length === 0 || words2.length === 0) return 0;

    const commonWords = words1.filter(word => words2.includes(word));
    const totalWords = new Set([...words1, ...words2]).size;

    const similarity = (commonWords.length / totalWords) * 100;

    if (text1.toLowerCase() === text2.toLowerCase()) {
        return 100;
    }

    return Math.round(similarity);
};

export const getMatchLevel = (similarity: number): MatchResult => {
    if (similarity >= 80) {
        return { matchLevel: "high", matchPercentage: similarity };
    } else if (similarity >= 60) {
        return { matchLevel: "mid", matchPercentage: similarity };
    } else if (similarity >= 30) {
        return { matchLevel: "low", matchPercentage: similarity };
    }
    return { matchLevel: "none", matchPercentage: similarity };
};